import { Notification } from 'element-ui'
import { isProd, isDef, isNull, Eval, Call } from './common'
import { utils } from '../utils'

export default function (options) {
  options = Object.assign({}, {
    method: 'get',
    url() { return null },
    payload() { return {} },
    confirm() { return '确定进行此操作?' },
    loadOnSuccess: undefined,

    $beforeConfirm() {},
    $onConfirmed() {},
    $onRejected() {},
    $beforeRequest() {},
    $onError(...args) { utils.DefaultErrorHandler.call(this, ...args) },
    $beforeSuccess() {},
    $onSuccess: NotifySuccess,
    $afterSuccess() {},
  }, options)

  return function (...args) {
    const randstr = utils.RandomStr(5)
    const url = Eval(this, options.url, ...args)
    const payload = Eval(this, options.payload, ...args)

    // request function
    const request = () => {
      const prevent = Call(this, options.beforeAction, ...args)
      if (prevent)
        return

      if (!isProd) console.info(`[${url}:${randstr}] submiting with `, payload)

      this.$http[options.type](url, payload)
        .then(r => {
          if (!isProd) console.info(`[${url}:${randstr}] got response with `, r)

          if (r.body && r.body.error)
            Call(this, options.$onError, r.body.error, ...args)
          else {
            if (isDef(options.loadOnSuccess))
              this.$store.dispatch(`load_${options.loadOnSuccess}`, this)
            Call(this, options.$beforeSuccess, r.body, ...args)
            Call(this, options.$onSuccess, r.body, ...args)
            Call(this, options.$afterSuccess, r.body, ...args)
          }
        })
        .catch(err => {
          if (!isProd) console.info(`[${url}:${randstr}] get error `, err)

          Call(this, options.$onError, err, ...args)
        })
    }

    // depend on `confirm` option, it may invoke request immediately or after user confirming
    const confirm = Eval(this, options.confirm, ...args)
    if (!isNull(confirm)) {
      this.$confirm(confirm, '确认')
        .then(() => {
          Call(this, options.$onConfirmed, ...args)
          request()
        })
        .catch(e => {
          Call(this, options.$onRejected, e, ...args)
        })
    } else
      request()
  }
}

export function NotifySuccess(options = {}) {
  Notification({
    title: '成功',
    message: '操作成功',
    type: 'success',
    ...options,
  })
}



// WEBPACK FOOTER //
// ./client/src/utils/form.js